import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "./NtText";
import NtTouchableEffect from "./NtTouchableEffect";
import NtMaterialIcon from "./NtMaterialIcon";
import { useTheme } from "../context/ThemeContext";

/**
 * Bordered tappable row with a checkbox indicator on the left and a label
 * (+ optional sub-label) on the right. Use for boolean settings inside
 * modal forms where a switch/toggle would feel heavy.
 *
 *   <NtToggleRow
 *     value={enabled}
 *     onChange={setEnabled}
 *     label="Enable inbound route"
 *     sub="Calls hit this route only when enabled."
 *   />
 */
function NtToggleRow({ value, onChange, label, sub, containerStyle }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  return (
    <NtTouchableEffect
      onPress={() => onChange && onChange(!value)}
      style={[styles.row, containerStyle]}
    >
      <NtMaterialIcon
        name={value ? "checkbox-marked" : "checkbox-blank-outline"}
        size={20}
        color={value ? theme.brand2 : theme.textDim}
      />
      <View style={styles.text}>
        <NtText style={styles.label}>{label}</NtText>
        {sub ? <NtText style={styles.sub}>{sub}</NtText> : null}
      </View>
    </NtTouchableEffect>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    row: {
      flexDirection: "row",
      alignItems: "center",
      paddingVertical: 10,
      paddingHorizontal: 12,
      borderWidth: 1,
      borderColor: t.borderSoft,
      borderRadius: t.radius,
    },
    text: { flex: 1, marginLeft: 10 },
    label: { fontSize: 13, fontWeight: "600", color: t.text },
    sub: { fontSize: 11, marginTop: 2, lineHeight: 15, color: t.textDim },
  });

export default NtToggleRow;
